import { UsageService } from "./usage";
import api from "..";

export default new UsageService(api);
